import { Injectable } from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpEvent, HttpHeaderResponse, HttpProgressEvent,
    HttpResponse, HttpUserEvent, HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import {TokenStorage} from './token.storage';
import 'rxjs/add/operator/do';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class Interceptor implements HttpInterceptor {
    constructor(private token: TokenStorage, private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
        let authReq = req;
        let reqUrl= req.url;

        if (this.token.getToken() != null) {
           // console.log("Req 2", authReq);
            authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + this.token.getToken())});
            //console.log("Req 3", authReq);
        }
        else{

            if (reqUrl.includes('/client/')){
                this.router.navigate(['login']); 
            }
            else{
                this.router.navigate(['admin/login']); 
            }
        }
        return next.handle(authReq).do(
            (event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // do stuff with response if you want
                }
            }, (err: any) => {
                    // console.log("Avant condition erreur");

                if (err instanceof HttpErrorResponse) {
                    // console.log("Dans erreur: ", err);
                    //console.log('req url :: ' + req.url + "Path : " + lastItem );
                   if (err.status === 401) {
                       this.token.removeToken();

                        if (reqUrl.includes('/client/')){
                            this.router.navigate(['login']); 
                        }
                        else{
                            this.router.navigate(['admin/login']); 
                        }
                    }
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/interceptor.ts